
const highlighted = {
  color: 'pink.200',
  fontWeight: 'bold',
  _hover: {
    color: 'pink.300'
  },
  _focus: {
    color: 'pink.400',
    boxShadow: 'none'
  }
}

export default {
  variants: {
    highlighted
  }
}